var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWrong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C15.5229 0 20 4.47714 20 10C20 15.5229 15.5229 20 10 20C4.47714 20 0 15.5229 0 10C5.0509e-05 4.47717 4.47717 5.05105e-05 10 0ZM12.6826 7.35352C12.4023 7.07316 11.9464 7.07316 11.666 7.35352L10.0186 9.00098L8.37012 7.35352C8.0898 7.0732 7.63485 7.07326 7.35449 7.35352C7.07414 7.63387 7.07414 8.08879 7.35449 8.36914L9.00195 10.0176L7.35449 11.665C7.07414 11.9454 7.07414 12.4013 7.35449 12.6816C7.63483 12.9617 8.08985 12.9618 8.37012 12.6816L10.0186 11.0332L11.666 12.6816C11.9464 12.962 12.4023 12.962 12.6826 12.6816C12.9629 12.4013 12.9629 11.9454 12.6826 11.665L11.0342 10.0176L12.6826 8.36914C12.9626 8.08886 12.9626 7.63379 12.6826 7.35352Z",
    fill: "#E4001C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrong);
export default __webpack_public_path__ + "static/media/wrong.a2407fce07bfb9cf6290beb0984282d4.svg";
export { ForwardRef as ReactComponent };